import React from "react";
import "../styles/styles.scss";
import "../styles/custom.css";
import "jquery-ui-dist/jquery-ui";
import Swiper from "swiper/bundle";
import api from "../services/products";
import TabHeader from "./detail/tabHeader";
import ProductDescriptionTab from "./detail/productDescriptionTab";
import ProductMarketingTab from "./detail/productMarketingTab";
import TechdataTab from "./detail/techdataTab";
import MeasuresTab from "./detail/measuresTab";
import PerformanceTab from "./detail/performanceTab";
import EquipmentsTab from "./detail/equipmentsTab";
import DownloadsTab from "./detail/downloadsTab";
import LinksTab from "./detail/linksTab";
import VideosTab from "./detail/videosTab";
import withRouter from "./withRouter";
import { withTranslation } from "react-i18next";
import "swiper/css/bundle";
import $ from "jquery";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import numberFormatter from "../util/numberFormat.js";
import i18n from "i18next";

class Detail extends React.Component {
  state = {
    id: 0,
    product: {},
    openTabs: {},
    frequency: "frequenz50",
    class: "metricISO",
    openLightbox: false,
    lightboxIndex: 0,
  };

  constructor(props) {
    super(props);
  }
  //Temporary
  getCurrentTechdataKey = () => {
    return this.state.frequency + this.state.class;
  };
  //Temporary
  getTechdataValue = (sizeName) => {
    const key = this.getCurrentTechdataKey();
    const rows = this.state.product.techdata?.data?.[key] ?? [];
    const row = rows.find((row) => row.size === sizeName);
    return row ? row.value : "";
  };

  isButtonSelected = (frequency, isoClass) => {
    if (this.state.class == isoClass && this.state.frequency == frequency) {
      return true;
    }

    return false;
  };
  changeFrequency = (frequency, isoClass) => {
    this.setState({
      frequency: frequency,
      class: isoClass,
    });
  };
  isMetricSelected = (isoClass) => {
    if (this.state.class == isoClass) {
      return true;
    }

    return false;
  };
  getFrequency = (key) => {
    switch (key) {
      case "frequenz50metricISO":
        return "50 Hz Si";
      case "frequenz60metricISO":
        return "60 Hz Si";
      case "frequenz60metricUS":
        return "60 Hz US";
      case "frequenz0metricUS":
        return "DC US";
      case "frequenz0metricISO":
        return "DC SI";
    }
  };
  getLink = (link) => {
    const langBase = document.querySelector('meta[name="langbase"]');

    if (langBase) {
      langBase = langBase.getAttribute("content");

      return langBase + link.replace(/^\/+/, "");
    }

    return link;
  };
  isButtonSelectedByKey = (key) => {
    const data = key.split("0");

    const frq = data[0] + "0";
    const iCls = data[1];

    if (this.state.class == iCls && this.state.frequency == frq) {
      return true;
    }

    return false;
  };
  changeFrequencyBykey = (key) => {
    const data = key.split("0");

    this.changeFrequency(data[0] + "0", data[1]);
  };
  componentDidMount() {
    const slug = this.props.params.slug;

    if (this.props.params.class && this.props.params.frequency) {
      this.state.frequency = "frequenz" + this.props.params.frequency;
      this.state.class = this.props.params.class;
    } else {
      this.state.frequency =
        (this.props.state && this.props.state.frequency) ??
        this.state.frequency;
      this.state.class =
        (this.props.state && this.props.state.class) ?? this.state.class;
    }

    this.setState({
      slug: slug,
    });

    api.getProduct(slug).then((data) => {
      this.setState(
        {
          product: data.product,
          selectedTab: data.product.product_description,
        },
        () => {
          $("document").ready(function ($) {
            // $([document.documentElement, document.body]).animate(
            //   {
            //     scrollTop: $(".product-details-container").offset().top,
            //   },
            //   700
            // );

            // $("body").on("click", ".tab", function () {
            //   $([document.documentElement, document.body]).animate(
            //     {
            //       scrollTop: $(".tabs-container").offset().top,
            //     },
            //     700
            //   );
            // });

            $(".slide-caption[data-slide-caption='0']").show();

            const swiper = new Swiper("#mySwiper", {
              direction: "horizontal",
              loop: true,
              spaceBetween: 0,
              breakpoints: {},
              observer: true,
              observeParents: true,
              resizeObserver: true,

              pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                bulletClass: "image-gallery-button",
                bulletElement: "div",
                clickable: true,
                currentClass: "selected",
              },

              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },

              scrollbar: {
                el: ".swiper-scrollbar",
              },
            });

            swiper.on("slideChange", function (e) {
              let index = e.realIndex;

              $(".slide-caption").hide();
              $(".slide-caption[data-slide-caption='" + index + "']").show();
            });
          });
        }
      );
    });
  }

  isTabOpen = (key) => {
    return !!this.state.openTabs[key];
  };
  toggleTab = (key) => {
    this.setState((prevState) => ({
      openTabs: {
        ...prevState.openTabs,
        [key]: !prevState.openTabs[key],
      },
    }));
  };

  render() {
    const { t } = this.props;
    if (Object.keys(this.state.product).length === 0) {
      return "";
    }
    return (
      <>
        <div id="page-wrapper">
          <section className="container-fluid ">
            <div className="detail-top">
              <div className="detail-top-container">
                <h1>Produktfinder</h1>

                <div className="product-details">
                  <div className="product-details-column">
                    <div className="product-details-images-container swiper">
                      <div id="mySwiper">
                        <div className="main-image-container swiper-wrapper">
                          {this.state.product.gallery.map((image, index) => (
                            <div className="swiper-slide">
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    openLightbox: true,
                                    lightboxIndex: index,
                                  });
                                }}
                              >
                                <img
                                  className="product-image"
                                  src={
                                    import.meta.env.VITE_IMAGES_BASE +
                                    image.image
                                  }
                                  alt={image.alt}
                                />
                              </a>
                            </div>
                          ))}
                          <Lightbox
                            open={
                              this.state.openLightbox &&
                              this.state.product.gallery.length > 0
                                ? true
                                : false
                            }
                            close={() => this.setState({ openLightbox: false })}
                            index={this.state.lightboxIndex}
                            slides={this.state.product.gallery.map((image) => ({
                              src:
                                import.meta.env.VITE_IMAGES_BASE + image.image,
                              title: image.caption,
                            }))}
                          />
                        </div>
                        {(() => {
                          if (this.state.product.gallery.length > 1) {
                            return (
                              <>
                                <div className="swiper-button-prev arrow slider-arrow-left"></div>
                                <div className="swiper-button-next arrow slider-arrow-right"></div>
                              </>
                            );
                          }
                        })()}
                        <div className="slide-captions">
                          {this.state.product.gallery.map((image, key) => (
                            <div
                              className="slide-caption"
                              data-slide-caption={key}
                              style={{ display: "none" }}
                            >
                              {image.caption}
                              <p>
                                <br />
                              </p>
                            </div>
                          ))}
                        </div>
                        {(() => {
                          if (this.state.product.gallery.length > 1) {
                            return (
                              <div className="swiper-pagination product-images-slider-container"></div>
                            );
                          }
                        })()}
                      </div>
                      <p></p>
                    </div>
                  </div>
                  <div className="product-details-description-container">
                    <h3 className="product-type">
                      {/*  {this.state.product.product_type} */}
                      {this.getTechdataValue("Produkttyp")}
                    </h3>
                    <h2 className="product-name">{this.state.product.title}</h2>
                    <h2>{this.state.product.product_type}</h2>
                    <div
                      className="product-description"
                      dangerouslySetInnerHTML={{
                        __html: this.state.product.description,
                      }}
                    ></div>
                    <div className="product-range">
                      {(() => {
                        const key = this.getCurrentTechdataKey();
                        const rows =
                          this.state.product.techdata?.data?.[key] ?? [];
                        const filtered = ["Förderhöhe", "Fördermenge"];

                        return rows
                          .filter((row) => filtered.includes(row.size))
                          .map((row, i) => {
                            // split "3–46 m" into ["3", "46 m"]
                            const parts = row.value.split("–");
                            const numbers = parts[0].trim();
                            const rest = parts[1]?.trim() ?? "";

                            // split "46 m" into number and unit
                            const [maxNum, ...unitParts] = rest.split(" ");
                            const unit = unitParts.join(" ");

                            const html =
                              row.size +
                              " <span class='range-value'>" +
                              numberFormatter.numberFormat(
                                parseFloat(numbers),
                                i18n.language
                              ) +
                              " - " +
                              numberFormatter.numberFormat(
                                parseFloat(maxNum),
                                i18n.language
                              ) +
                              " " +
                              unit +
                              "</span>";

                            return (
                              <p
                                key={i}
                                dangerouslySetInnerHTML={{ __html: html }}
                              />
                            );
                          });
                      })()}
                    </div>
                    {/* <p>{t('Phone')} <a href={"tel:" + this.state.product.contacts.phone}>{this.state.product.contacts.phone}</a></p> */}
                    {/* <p
                    dangerouslySetInnerHTML={{
                      __html: this.state.product.contacts.address,
                    }}
                  /> */}
                    <div class="product-mail">
                      <a
                        href={
                          "mailto:" +
                          this.state.product.contacts.email +
                          "?subject=" +
                          this.state.product.contacts.subject
                        }
                        className="send-email"
                      >
                        {t("Make a non-binding inquiry (e-mail)")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="container-fluid container-fluid-gray">
            <div className="container">
              <div className="detail page-content page-detail-content product-details-container">
                <div className="filter-controls-container ps">
                  <div
                    className={
                      "filter-row powers" +
                      (Object.values(this.state.product.frequency).length
                        ? " selected"
                        : "")
                    }
                  >
                    <h4>{t("Power supply/Unit")}</h4>
                    <div className="buttons-container">
                      {this.state.product.hasOwnProperty("techdata") &&
                        Object.keys(this.state.product.techdata.data).map(
                          (key, i) => (
                            <>
                              {
                                <button
                                  onClick={() => {
                                    this.changeFrequencyBykey(key);
                                  }}
                                  className={
                                    this.isButtonSelectedByKey(key)
                                      ? "selected"
                                      : ""
                                  }
                                >
                                  {this.getFrequency(key)}
                                </button>
                              }
                            </>
                          )
                        )}
                    </div>
                  </div>
                  <div className="clear-both"></div>
                </div>
                <div className="tabs-container">
                  <ul className="tabs selectable">
                    <TabHeader
                      isSelected={this.isTabOpen("product_description")}
                      data={this.state.product.product_description}
                      onClick={() => this.toggleTab("product_description")}
                      element={
                        <ProductDescriptionTab
                          selected={this.isTabOpen("product_description")}
                          data={this.state.product.product_description}
                        />
                      }
                    />
                    {this.state.product.hasOwnProperty("product_marketing") && (
                      <TabHeader
                        isSelected={this.isTabOpen("product_marketing")}
                        data={this.state.product.product_marketing}
                        onClick={() => this.toggleTab("product_marketing")}
                        element={
                          <ProductMarketingTab
                            selected={this.isTabOpen("product_marketing")}
                            data={this.state.product.product_marketing}
                          />
                        }
                      />
                    )}
                    {this.state.product.hasOwnProperty("techdata") && (
                      <TabHeader
                        isSelected={this.isTabOpen("techdata")}
                        data={this.state.product.techdata}
                        onClick={() => this.toggleTab("techdata")}
                        element={
                          <TechdataTab
                            selected={this.isTabOpen("techdata")}
                            techdata={this.state.product.techdata}
                            isButtonSelected={this.isButtonSelected}
                          />
                        }
                      />
                    )}
                    {this.state.product.hasOwnProperty("measures") && (
                      <TabHeader
                        isSelected={this.isTabOpen("measures")}
                        data={this.state.product.measures}
                        onClick={() => this.toggleTab("measures")}
                        element={
                          <MeasuresTab
                            selected={this.isTabOpen("measures")}
                            measures={this.state.product.measures}
                            isMetricSelected={this.isMetricSelected}
                          />
                        }
                      />
                    )}
                    {Object.keys(this.state.product.performance).length > 0 && (
                      <TabHeader
                        isSelected={this.isTabOpen("performance")}
                        data={this.state.product.performance}
                        onClick={() => this.toggleTab("performance")}
                        element={
                          <PerformanceTab
                            selected={this.isTabOpen("performance")}
                            performance={this.state.product.performance}
                            isButtonSelected={this.isButtonSelected}
                          />
                        }
                      />
                    )}
                    {this.state.product.hasOwnProperty("equipments") && (
                      <TabHeader
                        isSelected={this.isTabOpen("equipments")}
                        data={this.state.product.equipments}
                        onClick={() => this.toggleTab("equipments")}
                        element={
                          <EquipmentsTab
                            selected={this.isTabOpen("equipments")}
                            equipments={this.state.product.equipments}
                          />
                        }
                      />
                    )}

                    <TabHeader
                      isSelected={this.isTabOpen("downloads")}
                      data={this.state.product.downloads}
                      onClick={() => this.toggleTab("downloads")}
                      element={
                        <DownloadsTab
                          selected={this.isTabOpen("downloads")}
                          downloads={this.state.product.downloads}
                        />
                      }
                    />
                    <TabHeader
                      isSelected={this.isTabOpen("links")}
                      data={this.state.product.links}
                      onClick={() => this.toggleTab("links")}
                      element={
                        <LinksTab
                          selected={this.isTabOpen("links")}
                          links={this.state.product.links}
                          getLink={this.getLink}
                        />
                      }
                    />
                    <TabHeader
                      isSelected={this.isTabOpen("videos")}
                      data={this.state.product.videos}
                      onClick={() => this.toggleTab("videos")}
                      element={
                        <VideosTab
                          selected={this.isTabOpen("videos")}
                          videos={this.state.product.videos}
                          t={t}
                          imagesBase={import.meta.env.VITE_IMAGES_BASE}
                        />
                      }
                    />
                  </ul>
                </div>
                <div className="clear-both"></div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default withTranslation()(withRouter(Detail));
